import { useEffect } from "react";
import { Card, CardContent } from "@/components/ui/card";
import PageHero from "@/components/common/PageHero";
import { caseStudies, clientLogoItems } from "@/data/siteContent";

const PastClientsPage = () => {
  useEffect(() => {
    document.title = "Past Clients | Keshavlal & Company";
  }, []);

  return (
    <div data-testid="past-clients-page-root">
      <PageHero
        eyebrow="Past Clients"
        title="Trusted by Corporate Buyers and Distribution Networks"
        description="Client logo wall showcasing organizations from automobile, cement, retail, and education sectors."
        testId="past-clients-page-hero"
      />

      <section className="border-b border-slate-200 bg-white" data-testid="past-clients-logo-section">
        <div className="mx-auto w-full max-w-7xl px-4 py-14 sm:px-6 lg:px-8">
          <div className="grid gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4" data-testid="past-clients-logo-grid">
            {clientLogoItems.map((client, index) => (
              <div
                key={client.id}
                className="flex min-h-28 items-center justify-center rounded-xl border border-slate-200 bg-white p-4 shadow-sm"
                data-testid={`past-clients-logo-card-${index}`}
              >
                <img
                  src={client.logoUrl}
                  alt={client.alt}
                  className="safe-media-logo"
                  data-testid={`past-clients-logo-image-${index}`}
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-slate-50" data-testid="past-clients-case-studies-section">
        <div className="mx-auto w-full max-w-6xl px-4 py-14 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-semibold text-slate-900" data-testid="past-clients-case-studies-title">
            Corporate Branding Case Studies
          </h2>
          <div className="mt-8 grid gap-4 md:grid-cols-3" data-testid="past-clients-case-studies-grid">
            {caseStudies.map((study, index) => (
              <Card key={study.title} className="rounded-2xl border-slate-200" data-testid={`past-clients-case-study-card-${index}`}>
                <CardContent className="space-y-3 p-5">
                  <h3 className="text-lg font-semibold text-slate-900" data-testid={`past-clients-case-study-title-${index}`}>
                    {study.title}
                  </h3>
                  <p className="text-sm text-slate-600" data-testid={`past-clients-case-study-summary-${index}`}>
                    {study.summary}
                  </p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default PastClientsPage;